import React, { useState } from 'react';

import {
  useLoginMutation,
  useIsGoogleSSOMutation,
  useIsLoggedInQuery
} from '../../redux/apis/authApi';
import { notification } from '../../utils/notification';
import { getAuthErrorMessage } from '../../utils/handler';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { loginSchema } from '../../utils/schemas/auth';
import { TOST_MESSAGE, TOAST_TYPE } from '../../utils/constant/errorMessage';

import SignInCard from './SignInCard';
// import logo from '/Logo-white.webp';
import './SignIn.scss';

const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;

function SignIn() {
  const navigate = useNavigate();

  const [userLogin] = useLoginMutation();
  const [googleSSO] = useIsGoogleSSOMutation();
  const { refetch } = useIsLoggedInQuery();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      emailMobile: '',
      password: ''
    }
  });

  const emailMobile = watch('emailMobile');
  const password = watch('password');
  const hasBlank = !String(emailMobile || '').trim() || !String(password || '').trim();
  const hasClientErrors = Boolean(errors?.emailMobile || errors?.password);
  const disableSubmit = loading || hasBlank || hasClientErrors;

  const onSubmit = async (data) => {
    try {
      if (loading || hasBlank || hasClientErrors) return;
      const payload = {
        email: data?.emailMobile,
        password: data?.password
      };
      setLoading(true);
      const res = await userLogin(payload);
      if (res?.data?.success) {
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        // Refresh the shared auth query so the router sees us as logged in,
        // then navigate in-app. Avoids a full page reload (which re-mounted
        // and re-animated the login screen, causing the flicker).
        await refetch();
        navigate('/dashboard', { replace: true });
        setLoading(false);
        // navigate('2-step-authentication', { state: { email: data?.emailMobile } });
      } else {
        notification(getAuthErrorMessage(res), TOAST_ERROR);
        setLoading(false);
      }
    } catch (error) {
      notification(error?.message || TOST_MESSAGE.LOGIN_FAILED, TOAST_ERROR);
      setLoading(false);
    }
  };

  const handleSignInWithGoogle = async (data) => {
    try {
      setLoading(true);
      if (data?.credential) {
        const res = await googleSSO({ id_token: data.credential });
        if (res?.data?.data) {
          notification('Login Successfully', TOAST_SUCCESS);
          await refetch();
          navigate('/dashboard', { replace: true });
          setLoading(false);
        } else {
          notification(getAuthErrorMessage(res), TOAST_ERROR);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      notification(error?.message || TOST_MESSAGE.LOGIN_FAILED, TOAST_ERROR);
      setLoading(false);
    }
  };

  return (
    <div className="auth-signin">
      {/* Background wallpaper (public/SoftwareCoWallpaper.svg),
          stretched to fill the whole viewport. */}
      <div
        className="auth-signin__bg"
        aria-hidden
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/SoftwareCoWallpaper.png)`
        }}
      />
      <div className="auth-signin__overlay" aria-hidden />

      <div className="auth-signin__wrap auth-signin__wrap--left">
        <SignInCard
          register={register}
          errors={errors}
          onSubmit={handleSubmit(onSubmit)}
          handleSignInWithGoogle={handleSignInWithGoogle}
          loading={loading}
          disableSubmit={disableSubmit}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
        />
      </div>
    </div>
  );
}

export default SignIn;
